import { useCallback, useEffect, useState } from 'react';
import { userPreferencesApi } from '../services/api';

/**
 * Column order for a `ProjectsListTable`, persisted per user via
 * `userPreferencesApi` under `preferenceKey`. Falls back to `defaultOrder`
 * until the saved preference loads, and again for any column the saved
 * order is missing (e.g. a column added after the user last saved).
 */
export function useColumnOrder(preferenceKey: string, defaultOrder: string[]): [string[], (order: string[]) => void] {
  const [columnOrder, setColumnOrder] = useState<string[]>(defaultOrder);

  useEffect(() => {
    userPreferencesApi.getPreferences().then((prefs) => {
      const saved = prefs[preferenceKey];
      if (!Array.isArray(saved)) return;
      const validColumns = saved.filter((col: string) => defaultOrder.includes(col));
      const missingColumns = defaultOrder.filter(col => !validColumns.includes(col));
      setColumnOrder([...validColumns, ...missingColumns]);
    }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preferenceKey]);

  const handleReorder = useCallback((order: string[]) => {
    setColumnOrder(order);
    userPreferencesApi.savePreference(preferenceKey, order).catch((err) => {
      console.error('Failed to save column order:', err);
    });
  }, [preferenceKey]);

  return [columnOrder, handleReorder];
}
